export const AppConstants = {
  defaultDark: false,
  defaultTheme: 'Light',
  defaultScale: 12,
  defaultLocale: 'en-ZA',
  defaultDateFormat: 'DD/MM/YYYY',
  defaultInputStyle: 'outlined'
};
